import { Button, ConfigProvider, Modal, Spin, Select, Switch } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import style from "css/layout.module.css";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { closeAlert, openAlert } from "redux/slices/alertSlice";
import SpeakerOnly from "./layout/speakerOnly";
import Telepresence from "./layout/telepresence";
import Stacked from "./layout/stacked";
import OnePlusN from "./layout/onePlusN";
import AllEqual from "./layout/allEqual";
import OnePlusFive from "./layout/onePlusFive";
import OnePlusSeven from "./layout/onePlusSeven";
import OnePlusNine from "./layout/onePlusNine";
import OnePlusSixteen from "./layout/onePlusSixteen";
import AllEqualQuarters from "./layout/allEqualQuarters";
import AllEqualNinths from "./layout/allEqualNinths";
import AllEqualSixteenths from "./layout/allEqualSixteenths";
import AllEqualTwentyFifths from "./layout/allEqualTwentyFifths";

function CmsLayoutModal(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [init, setInit] = useState(false);
  const [template, setTemplate] = useState("");
  const [templateMaxCount, setTemplateMaxCount] = useState(0);
  const [layoutList, setLayoutList] = useState([]);
  const [participant, setParticipant] = useState([]);
  const [isOver, setIsOver] = useState(false);
  const [importance, setImportance] = useState("");
  const [oldImportance, setOldImportance] = useState("");
  const [selectedItem, setSelectedItem] = useState({
    name: "",
    id: "",
    participantId: "",
  });
  const [displayList, setDisplayList] = useState([]);
  const [beforeArea, setBeforeArea] = useState();

  const [fixNum, setFixNum] = useState(props.cospace.fixNum); // 고정배치 수 값
  const [selectOptions, setSelectOptions] = useState([]);
  const [speakerMode, setSpeakerMode] = useState(
    props.cospace.activeSpeakerMode
  );

  const getImportance = useCallback(() => {
    setLoading(true);

    const data = {
      list: props.participants,
    };

    axios
      .post("/active/importance", data)
      .then((res) => {
        if (res.status === 200) {
          const list = res.data.list;
          let dList = [];
          let pList = [];
          list.forEach((el) => {
            if (el.importance !== undefined && el.importance !== "") {
              const obj = {
                name: el.name,
                id: el.id,
                participantId: el.participantId,
                importance:
                  props.cospace.fixNum === templateCount(template)
                    ? props.cospace.activeSpeakerMode
                      ? Number(el.importance) - 1
                      : Number(el.importance)
                    : props.cospace.activeSpeakerMode
                    ? Number(el.importance) +
                      (templateCount(template) - props.cospace.fixNum) -
                      1
                    : Number(el.importance) +
                      (templateCount(template) - props.cospace.fixNum),
              };
              dList.push(obj);
            } else {
              pList.push(el);
            }
          });
          let setDList = [];
          const areaList = document.getElementsByClassName("endpoint_area");
          const lengthDiff = areaList.length - templateMaxCount;

          dList.forEach((el) => {
            const importance = el.importance;
            for (var i = 0; i < areaList.length; i++) {
              const pos = Number(importance) + lengthDiff;
              if (Number(areaList[i].id) === pos) {
                el.importance = pos;
                areaList[i].innerHTML = el.name;
                areaList[i].attributes.itemName = el.name;
                areaList[i].attributes.itemId = el.id;
                areaList[i].attributes.itemParticipantId = el.participantId;
                areaList[i].title = el.name;
                areaList[i].style.backgroundColor = "#ffcd8f";
                setDList.push(el);
              }
            }
          });
          setDList.forEach((el) => {
            dList = dList.filter((item) => item.id !== el.id);
          });
          setParticipant([...pList, ...dList]);
          setDisplayList(setDList);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [props.participants, templateMaxCount]);

  const templateCount = useCallback((layoutName) => {
    switch (layoutName) {
      case "speakerOnly":
        return 1;
      case "telepresence":
        return 7;
      case "stacked":
        return 7;
      case "onePlusN":
        return 6;
      case "allEqual":
        return 4;
      case "onePlusFive":
        return 6;
      case "onePlusSeven":
        return 8;
      case "onePlusNine":
        return 10;
      case "allEqualQuarters":
        return 4;
      case "allEqualNinths":
        return 9;
      case "allEqualSixteenths":
        return 16;
      case "allEqualTwentyFifths":
        return 25;
      case "onePlusSixteen":
        return 17;
      default:
        return 0;
    }
  }, []);

  const setFixedLayoutNum = useCallback(() => {
    const maxLayout = templateCount(template);

    let tmpItems = [];
    for (let i = 1; i <= maxLayout; i++) {
      tmpItems.push({ label: i, value: i });
    }

    setSelectOptions(tmpItems);
    // setFixNum(maxLayout);
  }, [template, templateCount]);

  useEffect(() => {
    if (props.open) {
      setTemplate(props.cospace.layout);
      setTemplateMaxCount(templateCount(props.cospace.layout));
      setFixNum(props.cospace.fixNum);
      setSpeakerMode(props.cospace.activeSpeakerMode);
      setLayoutList(props.layout);
      setInit(true);
    }
  }, [
    props.cospace.layout,
    props.layout,
    props.open,
    templateCount,
    props.cospace.fixNum,
    props.cospace.activeSpeakerMode,
  ]);

  useEffect(() => {
    if (init) {
      getImportance();
      setFixedLayoutNum();
      setSelectedItem({
        name: "",
        id: "",
        participantId: "",
      });
      setInit(false);
    }
  }, [getImportance, init, setFixedLayoutNum, template, templateCount]);

  const dispatch = useDispatch();

  const changeMeetingLayout = () => {
    setLoading(true);

    let url = "/active/layout";
    let data = {
      layout: template,
      cospaceId: props.cospace.id,
      callId: props.callId,
      templateMaxCount: templateCount(template),
      speakerMode: speakerMode, // 발언자 모드 (boolean)
      fixNum: fixNum, // 고정배치 수 (integer)
      participants: [...displayList, ...participant],
    };

    axios
      .post(url, data)
      .then((res) => {
        if (res.status === 200) {
          props.close();
          const obj = {
            title: t("MESSAGE.NOTIFICATION"),
            content: t("MESSAGE.LAYOUT_CHANGED"),
            submitEventHandler: () => {
              dispatch(closeAlert());
              props.isRefresh();
            },
          };
          dispatch(openAlert(obj));
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const endpointDrop = (e) => {
    // e.preventDefault();
    if (speakerMode && Number(e.target.id) === templateCount(template)) {
      const obj = {
        title: t("MESSAGE.NOTIFICATION"),
        content: t("MESSAGE.SPEAKER_MODE"),
        submitEventHandler: () => {
          e.target.style.backgroundColor = "#F3F3F3";
          dispatch(closeAlert());
        },
      };
      dispatch(openAlert(obj));
      return;
    } else if (
      fixNum < templateCount(template) &&
      templateCount(template) - fixNum > Number(e.target.id)
    ) {
      const obj = {
        title: t("MESSAGE.NOTIFICATION"),
        content: t("MESSAGE.FIXNUM_OVER"),
        submitEventHandler: () => {
          e.target.style.backgroundColor = "#F3F3F3";
          dispatch(closeAlert());
        },
      };
      dispatch(openAlert(obj));
      return;
    } else if (selectedItem.name !== "") {
      if (e.target.id === oldImportance) {
        setOldImportance("");
      } else {
        if (
          e.target.attributes.itemName !== undefined &&
          e.target.attributes.itemName !== "" &&
          e.target.attributes.itemId !== undefined &&
          e.target.attributes.itemId !== "" &&
          e.target.attributes.itemParticipantId !== undefined &&
          e.target.attributes.itemParticipantId !== ""
        ) {
          if (beforeArea !== undefined) {
            let newParticipantList = participant.filter(
              (el) => el.id !== e.target.attributes.itemId
            );
            newParticipantList = newParticipantList.filter(
              (el) => el.id !== selectedItem.id
            );
            // setParticipant([
            //   ...newParticipantList,
            //   {
            //     name: e.target.attributes.itemName,
            //     id: e.target.attributes.itemId,
            //   },
            // ]);

            let newDisplayList = displayList.filter(
              (el) => el.id !== e.target.attributes.itemId
            );
            newDisplayList = newDisplayList.filter(
              (el) => el.id !== selectedItem.id
            );
            setDisplayList([
              ...newDisplayList,
              {
                name: selectedItem.name,
                id: selectedItem.id,
                importance: importance,
                participantId: selectedItem.participantId,
              },
              {
                name: e.target.attributes.itemName,
                id: e.target.attributes.itemId,
                importance: oldImportance,
                participantId: e.target.attributes.itemParticipantId,
              },
            ]);

            // beforeArea.target.style.backgroundColor = "#F3F3F3";
            beforeArea.target.attributes.itemName =
              e.target.attributes.itemName;
            beforeArea.target.attributes.itemId = e.target.attributes.itemId;
            beforeArea.target.attributes.itemParticipantId =
              e.target.attributes.itemParticipantId;
            beforeArea.target.title = e.target.title;
            beforeArea.target.innerHTML = e.target.innerHTML;
            setBeforeArea(e);
          } else {
            let newParticipantList = participant.filter(
              (el) => el.id !== e.target.attributes.itemId
            );
            newParticipantList = newParticipantList.filter(
              (el) => el.id !== selectedItem.id
            );
            setParticipant([
              ...newParticipantList,
              {
                name: e.target.attributes.itemName,
                id: e.target.attributes.itemId,
                participantId: e.target.attributes.itemParticipantId,
              },
            ]);

            let newDisplayList = displayList.filter(
              (el) => el.id !== e.target.attributes.itemId
            );
            newDisplayList = newDisplayList.filter(
              (el) => el.id !== selectedItem.id
            );
            setDisplayList([
              ...newDisplayList,
              {
                name: selectedItem.name,
                id: selectedItem.id,
                importance: importance,
                participantId: selectedItem.participantId,
              },
            ]);
          }
        } else {
          if (beforeArea !== undefined) {
            const attr = beforeArea.target.attributes;
            const newDisplayList = displayList.filter(
              (el) => el.id !== attr.itemId
            );
            setDisplayList([
              ...newDisplayList,
              {
                name: selectedItem.name,
                id: selectedItem.id,
                importance: importance,
                participantId: selectedItem.participantId,
              },
            ]);
            const newParticipantsList = participant.filter(
              (el) => el.id !== attr.itemId
            );
            setParticipant(newParticipantsList);
            beforeArea.target.style.backgroundColor = "#F3F3F3";
            beforeArea.target.attributes.itemName = "";
            beforeArea.target.attributes.itemId = "";
            beforeArea.target.attributes.itemParticipantId = "";
            beforeArea.target.title = "";
            beforeArea.target.innerHTML = "";
            setBeforeArea();
          } else {
            const newDisplayList = displayList.filter(
              (el) => el.id !== selectedItem.id
            );
            setDisplayList([
              ...newDisplayList,
              {
                name: selectedItem.name,
                id: selectedItem.id,
                importance: importance,
                participantId: selectedItem.participantId,
              },
            ]);
            const newParticipantsList = participant.filter(
              (el) => el.name !== selectedItem.name
            );
            setParticipant(newParticipantsList);
          }
        }
        e.target.innerHTML = selectedItem.name;
        e.target.attributes.itemName = selectedItem.name;
        e.target.attributes.itemId = selectedItem.id;
        e.target.attributes.itemParticipantId = selectedItem.participantId;
        e.target.title = selectedItem.name;
        e.target.style.backgroundColor = "#ffcd8f";
      }
    }
    setSelectedItem({
      name: "",
      id: "",
      participantId: "",
    });
    setIsOver(false);
    setImportance("");
  };

  const endpointDragOver = (e) => {
    e.preventDefault();

    if (!isOver && selectedItem.name !== "") {
      setIsOver(true);
      if (speakerMode && e.target.className.includes("speakerArea")) {
        return;
      } else {
        setImportance(e.target.id);
        e.target.style.backgroundColor = "#ffcd8f";
      }
    }
  };

  const endpointDragLeave = (e) => {
    if (isOver && selectedItem.name !== "") {
      setIsOver(false);
      setImportance("");
      if (speakerMode && e.target.className.includes("speakerArea")) {
        return;
      }
      if (e.target.innerHTML === "") {
        e.target.style.backgroundColor = "#F3F3F3";
      }
    }
  };

  const moveEndpoint = (e) => {
    const attr = e.target.attributes;

    if (attr.itemName === undefined || attr.itemName === "") {
      return;
    } else if (attr.itemId === undefined || attr.itemId === "") {
      return;
    }
    setIsOver(true);
    setOldImportance(e.target.id);
    setImportance(e.target.id);
    setSelectedItem({
      name: attr.itemName,
      id: attr.itemId,
      participantId: attr.itemParticipantId,
    });
    setBeforeArea(e);
  };

  const templateRender = () => {
    switch (template) {
      case "speakerOnly":
        return (
          <SpeakerOnly
            onDrop={(e) => endpointDrop(e)}
            onDragOver={(e) => endpointDragOver(e)}
            onDragLeave={(e) => endpointDragLeave(e)}
            onDragStart={(e) => moveEndpoint(e)}
            speakerMode={speakerMode}
          />
        );
      case "telepresence":
        return (
          <Telepresence
            onDrop={(e) => endpointDrop(e)}
            onDragOver={(e) => endpointDragOver(e)}
            onDragLeave={(e) => endpointDragLeave(e)}
            onDragStart={(e) => moveEndpoint(e)}
            speakerMode={speakerMode}
          />
        );
      case "stacked":
        return (
          <Stacked
            onDrop={(e) => endpointDrop(e)}
            onDragOver={(e) => endpointDragOver(e)}
            onDragLeave={(e) => endpointDragLeave(e)}
            onDragStart={(e) => moveEndpoint(e)}
            speakerMode={speakerMode}
          />
        );
      case "onePlusN":
        return (
          <OnePlusN
            onDrop={(e) => endpointDrop(e)}
            onDragOver={(e) => endpointDragOver(e)}
            onDragLeave={(e) => endpointDragLeave(e)}
            onDragStart={(e) => moveEndpoint(e)}
            speakerMode={speakerMode}
          />
        );
      case "allEqual":
        return (
          <AllEqual
            onDrop={(e) => endpointDrop(e)}
            onDragOver={(e) => endpointDragOver(e)}
            onDragLeave={(e) => endpointDragLeave(e)}
            onDragStart={(e) => moveEndpoint(e)}
            speakerMode={speakerMode}
          />
        );
      case "onePlusFive":
        return (
          <OnePlusFive
            onDrop={(e) => endpointDrop(e)}
            onDragOver={(e) => endpointDragOver(e)}
            onDragLeave={(e) => endpointDragLeave(e)}
            onDragStart={(e) => moveEndpoint(e)}
            speakerMode={speakerMode}
          />
        );
      case "onePlusSeven":
        return (
          <OnePlusSeven
            onDrop={(e) => endpointDrop(e)}
            onDragOver={(e) => endpointDragOver(e)}
            onDragLeave={(e) => endpointDragLeave(e)}
            onDragStart={(e) => moveEndpoint(e)}
            speakerMode={speakerMode}
          />
        );
      case "onePlusNine":
        return (
          <OnePlusNine
            onDrop={(e) => endpointDrop(e)}
            onDragOver={(e) => endpointDragOver(e)}
            onDragLeave={(e) => endpointDragLeave(e)}
            onDragStart={(e) => moveEndpoint(e)}
            speakerMode={speakerMode}
          />
        );
      case "allEqualQuarters":
        return (
          <AllEqualQuarters
            onDrop={(e) => endpointDrop(e)}
            onDragOver={(e) => endpointDragOver(e)}
            onDragLeave={(e) => endpointDragLeave(e)}
            onDragStart={(e) => moveEndpoint(e)}
            speakerMode={speakerMode}
          />
        );
      case "allEqualNinths":
        return (
          <AllEqualNinths
            onDrop={(e) => endpointDrop(e)}
            onDragOver={(e) => endpointDragOver(e)}
            onDragLeave={(e) => endpointDragLeave(e)}
            onDragStart={(e) => moveEndpoint(e)}
            speakerMode={speakerMode}
          />
        );
      case "allEqualSixteenths":
        return (
          <AllEqualSixteenths
            onDrop={(e) => endpointDrop(e)}
            onDragOver={(e) => endpointDragOver(e)}
            onDragLeave={(e) => endpointDragLeave(e)}
            onDragStart={(e) => moveEndpoint(e)}
            speakerMode={speakerMode}
          />
        );
      case "allEqualTwentyFifths":
        return (
          <AllEqualTwentyFifths
            onDrop={(e) => endpointDrop(e)}
            onDragOver={(e) => endpointDragOver(e)}
            onDragLeave={(e) => endpointDragLeave(e)}
            onDragStart={(e) => moveEndpoint(e)}
            speakerMode={speakerMode}
          />
        );
      case "onePlusSixteen":
        return (
          <OnePlusSixteen
            onDrop={(e) => endpointDrop(e)}
            onDragOver={(e) => endpointDragOver(e)}
            onDragLeave={(e) => endpointDragLeave(e)}
            onDragStart={(e) => moveEndpoint(e)}
            speakerMode={speakerMode}
          />
        );
      default:
        break;
    }
  };

  const checkSpeckModeItem = useCallback(
    (item) => {
      if (templateCount(template) === Number(item.importance)) {
        return true;
      } else {
        return false;
      }
    },
    [templateCount, template]
  );

  const checkFixNumOverItem = useCallback(
    (item) => {
      if (templateCount(template) - fixNum >= Number(item.importance)) {
        return true;
      } else {
        return false;
      }
    },
    [templateCount, template, fixNum]
  );

  useEffect(() => {
    if (speakerMode && displayList.some(checkSpeckModeItem)) {
      let newParticipantList = displayList.filter(
        (el) => Number(el.importance) === templateCount(template)
      );
      let tmpArr = participant;
      for (let i = 0; i < newParticipantList.length; i++) {
        const item = newParticipantList[i];
        tmpArr.push({
          name: item.name,
          id: item.id,
          participantId: item.participantId,
        });
      }
      setParticipant([...tmpArr]);
      for (let i = 0; i < newParticipantList.length; i++) {
        let displayItem = newParticipantList[i];
        let removeId = document.getElementById(displayItem.importance);
        if (removeId !== null) {
          removeId.style.backgroundColor = "#F3F3F3";
          removeId.attributes.itemName = "";
          removeId.attributes.itemId = "";
          removeId.attributes.itemParticipantId = "";
          removeId.title = "";
          removeId.innerHTML = "";
        }
      }
      let newDisplayList = displayList.filter(
        (el) => templateCount(template) !== Number(el.importance)
      );
      setDisplayList([...newDisplayList]);
    }

    if (
      fixNum < templateCount(template) &&
      displayList.some(checkFixNumOverItem)
    ) {
      let newParticipantList = displayList.filter(
        (el) => templateCount(template) - fixNum >= Number(el.importance)
      );
      let tmpArr = participant;
      for (let i = 0; i < newParticipantList.length; i++) {
        const item = newParticipantList[i];
        tmpArr.push({
          name: item.name,
          id: item.id,
          participantId: item.participantId,
        });
      }
      setParticipant([...tmpArr]);
      for (let i = 0; i < newParticipantList.length; i++) {
        let displayItem = newParticipantList[i];
        let removeId = document.getElementById(displayItem.importance);
        if (removeId !== null) {
          removeId.style.backgroundColor = "#F3F3F3";
          removeId.attributes.itemName = "";
          removeId.attributes.itemId = "";
          removeId.attributes.itemParticipantId = "";
          removeId.title = "";
          removeId.innerHTML = "";
        }
      }
      let newDisplayList = displayList.filter(
        (el) => templateCount(template) - fixNum < Number(el.importance)
      );
      setDisplayList([...newDisplayList]);
    }

    if (fixNum < templateCount(template)) {
      for (let i = 1; i <= templateCount(template) - fixNum; i++) {
        let rSpeaker = document.getElementById(i);
        if (rSpeaker !== null) {
          rSpeaker.style.backgroundImage =
            "url('" +
            process.env.REACT_APP_CLIENT_URL +
            "img/layout/" +
            "random_speaker_icon.png')";
          rSpeaker.style.backgroundRepeat = "no-repeat";
          rSpeaker.style.backgroundPosition = "center";
        }
      }
      for (
        let i = templateCount(template) - fixNum + 1;
        i <= templateCount(template);
        i++
      ) {
        let speaker = document.getElementById(i);
        if (speaker !== null) {
          let url = "";
          if (i === templateCount(template) && speakerMode) {
            url =
              "url('" +
              process.env.REACT_APP_CLIENT_URL +
              "img/layout/speaker_icon.png')";
          } else {
            url =
              "url('" +
              process.env.REACT_APP_CLIENT_URL +
              "img/layout/number/" +
              (templateCount(template) - i + 1) +
              ".png')";
          }
          speaker.style.backgroundImage = url;
          speaker.style.backgroundRepeat = "no-repeat";
          speaker.style.backgroundPosition = "center";
        }
      }
    } else if (fixNum === templateCount(template)) {
      for (let i = 1; i <= templateCount(template); i++) {
        let speaker = document.getElementById(i);
        if (speaker !== null) {
          let url = "";
          if (i === templateCount(template) && speakerMode) {
            url =
              "url('" +
              process.env.REACT_APP_CLIENT_URL +
              "img/layout/speaker_icon.png')";
          } else {
            url =
              "url('" +
              process.env.REACT_APP_CLIENT_URL +
              "img/layout/number/" +
              (templateCount(template) - i + 1) +
              ".png')";
          }
          speaker.style.backgroundImage = url;
          speaker.style.backgroundRepeat = "no-repeat";
          speaker.style.backgroundPosition = "center";
        }
      }
    }
  }, [
    speakerMode,
    fixNum,
    displayList,
    participant,
    template,
    checkSpeckModeItem,
    checkFixNumOverItem,
    templateCount,
  ]);

  return (
    <Modal
      centered
      open={props.open}
      onCancel={props.close}
      footer={null}
      width="auto"
      title={t("BTN.CHANGE_LAYOUT")}
    >
      <div className={style.container}>
        <section className={style.layout_list_wrap}>
          <div className={style.layout_list_container}>
            {layoutList.length > 0 &&
              layoutList.map((el, idx) => (
                <div key={idx}>
                  <LayoutItem
                    img={
                      process.env.REACT_APP_CLIENT_URL +
                      "img/layout/cms/" +
                      el +
                      ".png"
                    }
                    label={el}
                    clickEvent={() => {
                      if (loading) {
                        return;
                      } else {
                        setTemplate(el);
                        setFixNum(templateCount(el));
                        setInit(true);
                      }
                    }}
                  />
                </div>
              ))}
          </div>
        </section>

        <section className={style.template_container}>
          <div className={style.btn_area}>
            <p>{template}</p>
            <div>
              <ConfigProvider
                theme={{
                  token: {
                    fontFamily: "Spoqa Han Sans Neo",
                  },
                }}
              >
                <Button
                  size="small"
                  type="primary"
                  onClick={() => changeMeetingLayout()}
                  loading={loading}
                >
                  {t("BTN.APPLY_CHANGE")}
                </Button>
              </ConfigProvider>

              <ConfigProvider
                theme={{
                  token: {
                    fontFamily: "Spoqa Han Sans Neo",
                  },
                  components: {
                    Button: {
                      colorPrimaryText: "#ffffff",
                      colorTextLightSolid: "#ffffff",
                      colorText: "#ffffff",
                      colorError: "#ff4d4f",
                      colorErrorHover: "#ff7875",
                      colorErrorActive: "#d9363e",
                    },
                  },
                }}
              >
                <Button
                  size="small"
                  type="primary"
                  danger
                  onClick={() => setInit(true)}
                  loading={loading}
                >
                  {t("RESET_LAYOUT")}
                </Button>
              </ConfigProvider>
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              고정배치 수:
              <Select
                // defaultValue={search.SEARCH_MEETING_TYPE}
                value={fixNum}
                // style={{ width: 200 }}
                onChange={(value) => setFixNum(value)}
                options={selectOptions}
              />
            </div>
            <div
              style={{
                marginLeft: "30px",
                display: "flex",
                alignItems: "center",
              }}
            >
              발언자 모드:
              <Switch
                checkedChildren="ON"
                unCheckedChildren="OFF"
                // defaultUnchecked
                checked={speakerMode}
                onChange={(e) => {
                  setSpeakerMode(e);
                }}
              />
            </div>
          </div>

          <div className={style.template_area}>
            {loading ? (
              <div className={style.layout_spin}>
                <Spin />
              </div>
            ) : (
              <></>
            )}
            {!init && templateRender()}
          </div>

          <div className={style.endpoint_wrap}>
            <p className={style.endpoint_title}>{t("LABEL.DEVICE_LIST")}</p>
            <div
              className={style.endpoint_container}
              onMouseOver={(e) => {
                if (
                  beforeArea !== undefined &&
                  selectedItem.id !== "" &&
                  selectedItem.name !== "" &&
                  selectedItem.participantId !== ""
                ) {
                  e.stopPropagation();
                  e.preventDefault();

                  const newDisplayList = displayList.filter(
                    (el) => el.id !== selectedItem.id
                  );
                  setDisplayList(newDisplayList);
                  setParticipant([
                    ...participant,
                    {
                      name: selectedItem.name,
                      id: selectedItem.id,
                      participantId: selectedItem.participantId,
                    },
                  ]);
                  beforeArea.target.style.backgroundColor = "#F3F3F3";
                  beforeArea.target.attributes.itemName = "";
                  beforeArea.target.attributes.itemId = "";
                  beforeArea.target.attributes.itemParticipantId = "";
                  beforeArea.target.title = "";
                  beforeArea.target.innerHTML = "";
                  setBeforeArea();
                }
              }}
            >
              {participant.length > 0 &&
                participant.map((el, idx) => (
                  <div key={idx}>
                    <EndpointItem
                      label={el.name}
                      onDragStart={() => {
                        setOldImportance("");
                        setSelectedItem({
                          name: el.name,
                          id: el.id,
                          participantId: el.participantId,
                        });
                      }}
                    />
                  </div>
                ))}
            </div>
          </div>
        </section>
      </div>
    </Modal>
  );
}

export default CmsLayoutModal;

function LayoutItem({ img, label, clickEvent, onDragStart }) {
  return (
    <div
      className={`${style.layout_item} cursor`}
      onClick={clickEvent}
      onDragStart={onDragStart}
    >
      <img src={img} alt="" />
      <p>{label}</p>
    </div>
  );
}

function EndpointItem({ label, onDragStart }) {
  return (
    <div
      className={`${style.endpoint_item} cursor`}
      onDragStart={onDragStart}
      draggable
    >
      {label}
    </div>
  );
}
